import { useStore } from 'effector-vue/composition';
import { authStore } from '@/store/auth';

export function isVoxUser(): boolean {
  const auth = useStore(authStore);
  return auth.value.email?.includes('@voximplant.com') || false;
}
